export default "__VITE_ASSET__BoO63idw__"